export const europeanCountries = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LI",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "GB",
    "NO",
    "SE",
    "UA",
    "RU",
    "CH",
    "US",
    "AD",
    "ES",
    "ES",
    "FR",
    "FO",
    "GI",
    "IM",
    "AX",
];

/**
 * Return HTML autocomplete value for a given field name.
 * Unknown fields return undefined (nepridaj autocomplete atribút).
 */
export function getAutocomplete(fieldName: string): string | undefined {
    if (!fieldName) return undefined;

    // normalize: lower, trim, remove brackets, collapse spaces, replace separators
    const raw = fieldName
        .toLowerCase()
        .replace(/\[|\]|\(|\)/g, "")
        .replace(/[-\s]+/g, "_")
        .trim();

    // helpers
    const has = (s: string) => raw.includes(s);

    // Explicit overrides / special IDs, GUIDs, tokens -> autocomplete off
    if (/(guid|uuid|token|id|reservation|driver).*?_?(guid|uuid|token)?/.test(raw)) {
        return "off";
    }

    // Email
    if (/^email$|e_?mail/.test(raw)) return "email";

    // Phone
    if (/^tel$|phone|mobile|gsm|telefon/.test(raw)) return "tel";

    // Person names
    if (/^name$|^first_?name$|given_?name|krstne/.test(raw)) return "given-name";
    if (/^last_?name$|family_?name|surname|priezvisko/.test(raw)) return "family-name";
    if (/^middle_?name$/.test(raw)) return "additional-name";
    if (/^nickname$|nick|prezývka|username/.test(raw)) return "nickname"; // for login use "username"

    // Birthday / DOB
    if (/^birth(date|day)?$|^dob$|bday|date_of_birth/.test(raw)) return "bday";

    // Organization
    if (/company|organization|firma/.test(raw)) return "organization";

    // Country: code vs full name
    if (/country(_?code)?$/.test(raw)) {
        return has("code") ? "country" : "country-name";
    }

    // Zip / postal code
    if (/^zip$|postal_?code|postcode|psc/.test(raw)) return "postal-code";

    // Address lines
    if (/address_?line_?1|ulica_?1/.test(raw)) return "address-line1";
    if (/address_?line_?2|ulica_?2|apartment|flat|byt/.test(raw)) return "address-line2";
    if (/street|adresa|address$/.test(raw)) return "street-address";

    // City / Town (address-level2)
    if (/^city$|^town$|mesto|obec|address_?level2/.test(raw)) return "address-level2";

    // Region / State (address-level1)
    if (/^state$|region|kraj|okres|address_?level1/.test(raw)) return "address-level1";

    // Neighborhood / address-level3
    if (/district|neighborhood|sidlisko|address_?level3/.test(raw)) return "address-level3";

    // House number
    if (/house_?number|cislo_?domu|cp|orientacne/.test(raw)) return "street-address";

    // Fallback: nothing matched
    return undefined;
}
